<template>
  <div class="nuttrema-change-language" :style="{ textAlign: align || '' }">
     <el-dropdown :size="size" :placement="placement">
      <span class="el-dropdown-link">
        <!-- {{ _get(currentLanguage, 'native_name', $t('label.language')) }} <i class="el-icon-arrow-down el-icon--right"></i> -->
        {{ $t('label.change_language') }} <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
           v-for="language in _get(SettingsLanguages, 'data', [])"
          :class="{ 'is-active': currentCode === language.code }"
          :key="language.id">
          <a @click="handleChangeLanguage(language.code)">{{ language.native_name }}</a>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { find, get } from 'lodash';
import { mapGetters } from 'vuex';

export default {
  name: 'nuttrema-change-language',
  props: {
    placement: {
      required: false,
      default: 'bottom-end',
    },
    align: {
      required: false,
      default: null,
    },
    size: {
      required: false,
      default: 'mini',
    },
  },
  computed: {
    ...mapGetters([
      'SettingsLanguages',
    ]),
    currentLanguage() {
      return find(get(this.SettingsLanguages, 'data', []), language => language.code === this.$locale.current());
    },
    currentCode() {
      return this.$locale.current();
    },
  },
  methods: {
    handleChangeLanguage(value) {
      this.$locale.change(value);
    },
  },
};
</script>

<style lang="scss" scoped>
  .nuttrema-change-language {
    &:hover, &:focus, &:active {
      cursor: pointer;
    }

    /deep/ .el-dropdown-link {
      font-weight: 400;
      font-size: 0.9rem;
      > i {
        font-weight: 600;
      }
    }

    &.is-in-form {
      /deep/ .el-dropdown-link {
        font-size: 1rem;
        font-weight: 500;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/button/nuttrema-change-language.vue